import { Header } from './Header';

export type { HeaderProps } from './Header';
export default Header;
